import { compose } from 'redux';

import type { RoutingState } from '../routingStore';

export const selectRoutesDomain = (state: RoutingState) => state.routes;

export const selectUpdatedRouteWebData = compose((state) => state.updatedRouteWebData, selectRoutesDomain);

export const selectRouteExecutionInfoWebData = compose((state) => state.routeExecutionInfoWebData, selectRoutesDomain);

export const selectDeletedRoutesWebData = compose((state) => state.deletedRoutesWebData, selectRoutesDomain);

export const selectExportRoutesWebData = compose((state) => state.exportRoutesWebData, selectRoutesDomain);

export const selectExportedReportWebData = compose((state) => state.exportedReportWebData, selectRoutesDomain);
